import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import MatchList from "../Match/components/MatchList";
import PrevArrow from "../Components/PrevArrow";
import NextArrow from "../Components/NextArrow";
import { loaderStateTrue, loaderStateFalse } from "../../slices/mainSlice";
import { getPlayerListApi, getTeamListApi } from "../Team/TeamController";
import { getMatchListApi } from "../Match/MatchController";
import TopTeams from "../Components/TopTeams";

const FixturesHistory = () => {
	const { t } = useTranslation();
	const [activeTab, setActiveTab] = useState("tab1");
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { language } = useSelector((state) => state.language);

	const [playerList, setPlayerList] = useState([]);
	const [matchList, setMatchList] = useState([]);
	const [teamList, setTeamList] = useState([]);

	const tabs = [
		{ id: "tab1", label: "Statistiques" },
		{ id: "tab2", label: "Escouades" },
		{ id: "tab3", label: "Information" },
	];

	const settings = {
		dots: false,
		arrows: true,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 4000,
		speed: 1000,
		slidesToShow: 1,
		slidesToScroll: 1,
		prevArrow: <PrevArrow />,
		nextArrow: <NextArrow />,
		responsive: [
			{
				breakpoint: 1024,
				settings: { slidesToShow: 1 }
			},
			{
				breakpoint: 640,
				settings: { slidesToShow: 1 }
			}
		]
	};

	useEffect(() => {
		getPlayerList();
		getMatchList();
		getTeamList();
	}, []);

	const getPlayerList = async () => {
		try {
			dispatch(loaderStateTrue());

			const response = await getPlayerListApi();
			const data = response?.data || [];

			// Format players by position
			const grouped = data.reduce((acc, player) => {
				(player.position || []).forEach(pos => {
					let group = acc.find(g => g.position === pos);

					if (!group) {
						group = { position: pos, players: [] };
						acc.push(group);
					}

					group.players.push({
						...player
						// _id: player._id,
						// fullName: player.fullName,
						// dateOfBirth: player.dob,
						// nationality: player.nationality || "",
					});
				});
				return acc;
			}, []);

			setPlayerList(grouped);

		} catch (error) {
			console.log("Error fetching players:", error);
		} finally {
			dispatch(loaderStateFalse());
		}
	};

	const getMatchList = () => {
		try {
			dispatch(loaderStateTrue());
			getMatchListApi()
				.then((response) => {
					let responseData = response.data?.result || [];
					console.log("responseDataresponseDataresponseData", responseData)
					setMatchList(responseData);
					dispatch(loaderStateFalse());
				})
				.catch((error) => {
					console.log(error);
					dispatch(loaderStateFalse());
				});
		} catch (error) {
			console.log(error);
			dispatch(loaderStateFalse());
		}
	};

	const getTeamList = () => {
		try {
			dispatch(loaderStateTrue());
			getTeamListApi()
				.then((response) => {
					let responseData = response.data?.result || [];
					console.log("responseDataresponseDataresponseData", responseData)
					setTeamList(responseData);
					dispatch(loaderStateFalse());
				})
				.catch((error) => {
					console.log(error);
					dispatch(loaderStateFalse());
				});
		} catch (error) {
			console.log(error);
			dispatch(loaderStateFalse());
		}
	};

	return (
		<main className="main p-4 relative">
			<div className="flex flex-wrap items-start gap-y-6 -mx-2">
				<div className="lg:w-4/6 w-full px-2">
					<div className="space-y-5">
						<div className="relative">
							<div className="rounded-xl absolute inset-0 bg-[#F8F8F8] overflow-hidden">
								<div className="absolute -skew-x-[20deg] w-[14vw] top-0 -left-12 bottom-0 bg-[#B50613] before:content-[''] before:absolute before:w-1/3 before:top-0 before:left-0 before:bottom-0 before:bg-black/20"></div>
								<div className="absolute -skew-x-[20deg] w-[14vw] top-0 -right-12 bottom-0 bg-[#FFD600] before:content-[''] before:absolute before:w-1/3 before:top-0 before:right-0 before:bottom-0 before:bg-black/10"></div>
							</div>
							<div className="relative bg-cover bg-no-repeat bg-center h-full text-center">
								<div className="flex max-sm:flex-wrap lg:justify-between justify-center items-center size-full">
									<div className="flex-none w-1/2 lg:w-1/4 p-4 relative flex justify-end">
										<div className="size-32 flex justify-center items-center p-4 rounded-full border light-border bg-white shadow-xl">
											<img src={require("../../assets/images/clubs/sb29.png")} alt="" />
										</div>
									</div>
									<div className="p-5 flex justify-center items-center max-sm:order-last w-full lg:w-2/4">
										<div className="space-y-2">
											<h4 className="lg:text-xl md:text-lg text-base font-bold uppercase text-gray-400">30 August 2025</h4>
											<p className="my-5 font-secondary lg:text-6xl text-3xl font-black leading-none text-gray-800">1:00</p>

											<div className="flex w-full max-w-md overflow-hidden rounded-xl font-bold text-white text-sm select-none">
												<div className="flex-none w-[45%] bg-[#9E1B1B] flex justify-center items-center relative">
													<span className="p-2">45%</span>
												</div>

												<div className="flex-none w-[5%] bg-gray-200 text-black flex justify-center items-center relative z-[1] after:content-[''] after:absolute after:top-0 after:left-[-10px] after:bottom-0 after:right-[-10px] after:bg-gray-200 after:skew-x-12">
													<span className="p-2 relative z-[2]">5%</span>
												</div>

												<div className="flex-none w-[50%] bg-[#EAC600] text-white flex justify-center items-center rounded-r-xl">
													<span className="p-2">50%</span>
												</div>
											</div>


											<p className="font-secondary lg:text-xl font-bold md:text-lg text-base uppercase text-gray-400">Racing Club de Lens Stade Brestois 29</p>
										</div>
									</div>
									<div className="flex-none w-1/2 lg:w-1/4 p-4 relative flex justify-start">
										<div className="size-32 flex justify-center items-center p-4 rounded-full border light-border bg-white shadow-xl">
											<img src={require("../../assets/images/clubs/rcl.png")} alt="" />
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="flex items-center gap-3">
							<h3 className="xl:text-2xl text-xl font-extrabold uppercase">Classement de la Ligue 1 McDonald's</h3>
							<select className="form-select font-bold !max-w-[200px]">
								<option value="">Saison 2025/25</option>
								<option value="">Saison 2025/25</option>
							</select>
							<button className="btn btn-primary text-nowrap ml-auto">{t('seeAll')}</button>
						</div>

						{/* <div className="">
						<ul className="mb-3 nav nav-tabs flex border-b light-border [&>*]:flex-1 [&>*]:nav-item [&>*]:inline-flex [&>*]:justify-center [&>*]:items-center [&>*]:gap-1">
							<li className="nav-item active"><a href="fixtures-history.html">Statistiques</a></li>
							<li className="nav-item"><a href="fixtures-history-squads.html">Escouades</a></li>
							<li className="nav-item"><a href="fixtures-history-information.html">Information</a></li>
						</ul>

						<div className="tab-content space-y-4">
							<div className="overflow-x-auto">
								<table className="table table-row-hover w-full">
									<thead className="border-b light-border">
										<tr>
											<th>Temps</th>
											<th>Équipes</th>
											<th className="text-center">Score</th>
											<th className="text-center">Pts</th>
											<th className="text-center">Stats</th>
											<th className="text-center">pari</th>
										</tr>
									</thead>

									<tbody className="divide-y divide-gray-200 [&_tr_td]:align-top">
										<tr>
											<td width="24">
												<p className="time text-xs font-secondary text-nowrap">12:30</p>
												<p className="date text-xs font-secondary text-nowrap text-gray-500">26 Aug</p>
											</td>
											<td>
												<div className="flex max-sm:flex-wrap items-center gap-3">
													<ul className="flex -space-x-2 rtl:space-x-reverse">
														<li className="p-2 size-10 flex justify-center items-center border border-primary-200 rounded-full bg-white">
															<img className="size-7 object-contain dark:border-gray-800" src="assets/images/clubs/paris.png" alt="" />
														</li>
														<li className="p-2 size-10 flex justify-center items-center border border-primary-200 rounded-full bg-white">
															<img className="size-7 object-contain dark:border-gray-800" src="assets/images/clubs/sb29.png" alt="" />
														</li>
													</ul>
													<div>
														<p className="uppercase">Racing Club de Lens</p>
														<p className="uppercase text-gray-400">Stade Brestois 29</p>
													</div>
												</div>
											</td>
											<td className="text-nowrap">
												<div className="score-result flex flex-col items-center gap-1">
													<span className="active">2</span>			
													<span>1</span>		
												</div>
											</td>
											<td className="text-nowrap">
												<div className="point-result flex flex-col items-center gap-1">
													<span className="up">9</span>			
												</div>
											</td>
											<td className="text-center">
												<img src="assets/images/icons/bar-chart.svg" alt="" className="inline" />
											</td>
											<td className="text-center font-medium">24</td>
										</tr>
										<tr>
											<td width="24">
												<p className="time text-xs font-secondary text-nowrap">12:30</p>
												<p className="date text-xs font-secondary text-nowrap text-gray-500">26 Aug</p>
											</td>
											<td>
												<div className="flex max-sm:flex-wrap items-center gap-3">
													<ul className="flex -space-x-2 rtl:space-x-reverse">
														<li className="p-2 size-10 flex justify-center items-center border border-primary-200 rounded-full bg-white">
															<img className="size-7 object-contain dark:border-gray-800" src="assets/images/clubs/paris.png" alt="" />
														</li>
														<li className="p-2 size-10 flex justify-center items-center border border-primary-200 rounded-full bg-white">
															<img className="size-7 object-contain dark:border-gray-800" src="assets/images/clubs/sb29.png" alt="" />
														</li>
													</ul>
													<div>
														<p className="uppercase">Racing Club de Lens</p>
														<p className="uppercase text-gray-400">Stade Brestois 29</p>
													</div>
												</div>
											</td>
											<td className="text-nowrap">
												<div className="score-result flex flex-col items-center gap-1">
													<span className="active">2</span>			
													<span>1</span>		
												</div>
											</td>
											<td className="text-nowrap">
												<div className="point-result flex flex-col items-center gap-1">
													<span className="down">3</span>			
												</div>
											</td>
											<td className="text-center">
												<img src="assets/images/icons/bar-chart.svg" alt="" className="inline" />
											</td>
											<td className="text-center font-medium">24</td>
										</tr>
										<tr>
											<td width="24">
												<p className="time text-xs font-secondary text-nowrap">12:30</p>
												<p className="date text-xs font-secondary text-nowrap text-gray-500">26 Aug</p>
											</td>
											<td>
												<div className="flex max-sm:flex-wrap items-center gap-3">
													<ul className="flex -space-x-2 rtl:space-x-reverse">
														<li className="p-2 size-10 flex justify-center items-center border border-primary-200 rounded-full bg-white">
															<img className="size-7 object-contain dark:border-gray-800" src="assets/images/clubs/paris.png" alt="" />
														</li>
														<li className="p-2 size-10 flex justify-center items-center border border-primary-200 rounded-full bg-white">
															<img className="size-7 object-contain dark:border-gray-800" src="assets/images/clubs/sb29.png" alt="" />
														</li>
													</ul>
													<div>
														<p className="uppercase">Racing Club de Lens</p>
														<p className="uppercase text-gray-400">Stade Brestois 29</p>
													</div>
												</div>
											</td>
											<td className="text-nowrap">
												<div className="score-result flex flex-col items-center gap-1">
													<span className="active">2</span>			
													<span>1</span>		
												</div>
											</td>
											<td className="text-nowrap">
												<div className="point-result flex flex-col items-center gap-1">
													<span className="up">9</span>			
												</div>
											</td>
											<td className="text-center">
												<img src="assets/images/icons/bar-chart.svg" alt="" className="inline" />
											</td>
											<td className="text-center font-medium">24</td>
										</tr>
										<tr>
											<td width="24">
												<p className="time text-xs font-secondary text-nowrap">12:30</p>
												<p className="date text-xs font-secondary text-nowrap text-gray-500">26 Aug</p>
											</td>
											<td>
												<div className="flex max-sm:flex-wrap items-center gap-3">
													<ul className="flex -space-x-2 rtl:space-x-reverse">
														<li className="p-2 size-10 flex justify-center items-center border border-primary-200 rounded-full bg-white">
															<img className="size-7 object-contain dark:border-gray-800" src="assets/images/clubs/rfef.png" alt="" />
														</li>
														<li className="p-2 size-10 flex justify-center items-center border border-primary-200 rounded-full bg-white">
															<img className="size-7 object-contain dark:border-gray-800" src="assets/images/clubs/fff.png" alt="" />
														</li>
													</ul>
													<div>
														<p className="uppercase">Racing Club de Lens</p>
														<p className="uppercase text-gray-400">Stade Brestois 29</p>
													</div>
												</div>
											</td>
											<td className="text-nowrap">
												<div className="score-result flex flex-col items-center gap-1">
													<span className="active">2</span>			
													<span>1</span>		
												</div>
											</td>
											<td className="text-nowrap">
												<div className="point-result flex flex-col items-center gap-1">
													<span className="up">9</span>			
												</div>
											</td>
											<td className="text-center">
												<img src="assets/images/icons/bar-chart.svg" alt="" className="inline" />
											</td>
											<td className="text-center font-medium">24</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div> */}



						<div className="">
							<ul className="mb-3 nav nav-tabs flex border-b light-border [&>*]:flex-1 [&>*]:nav-item [&>*]:inline-flex [&>*]:justify-center [&>*]:items-center [&>*]:gap-1">
								{tabs.map((tab) => (
									<li
										key={tab.id}
										className={`nav-item ${activeTab === tab.id
											? "active"
											: ""
											}`}
										onClick={() => setActiveTab(tab.id)}
									>
										<button>{tab.label}</button>
									</li>
								))}
							</ul>
							<div className="tab-content space-y-4">
								{activeTab === "tab1" && (
									<div className="tab-pane">
										<MatchList matchList={matchList} />
									</div>
								)}
								{activeTab === "tab2" && (
									<div className="tab-pane">
										<div className="overflow-x-auto space-y-4">
											{playerList.map((element, index) => (
												<table key={index} className="table table-striped table-row-hover w-full">
													<thead className="border-b light-border">
														<tr>
															<th className="text-lg font-bold" colSpan={4}>{element.position} - {element.players.length}</th>
														</tr>
													</thead>
													<tbody className="divide-y divide-gray-200">
														{element?.players.map((childElement, index) => (
															<tr key={index}>
																<td width={32} className='w-20'>
																	<label className="relative inline-flex items-center gap-1.5 cursor-pointer">
																		<input type="checkbox" className="input-checkbox" checked={childElement?.teamJoinStatus === "approved"} />
																		<span className="font-secondary font-semibold text-nowrap">#1</span>
																	</label>
																</td>
																<td>
																	<div className="flex max-sm:flex-wrap items-center gap-3">
																		<div className="w-10">
																			<img className="w-full" src="assets/images/players-list/4.png" alt="" />
																		</div>
																		<div>
																			<p className="font-bold uppercase">{childElement?.fullName}</p>
																		</div>
																	</div>
																</td>
																<td className='text-right'>
																	<span className="px-3 py-1 inline-flex gap-1 items-center text-xs font-semibold text-white rounded-full bg-green-500">
																		<img src="assets/images/icons/star-fill.svg" alt="Star" width="16" className="icon-white" /> 4.5
																	</span>
																</td>
																{/* <td className='text-right'>
												<span className="px-3 py-1 inline-flex gap-1 items-center text-xs font-semibold text-white rounded-full bg-yellow-500">
													<img src="assets/images/icons/star-fill.svg" alt="Star" width="16" className="icon-white" /> 2.5
												</span>
											</td> */}
															</tr>
														))}
													</tbody>
												</table>))}
										</div>
									</div>
								)}
								{activeTab === "tab3" && (
									<div className="tab-pane">
										<div class="flex flex-wrap -mx-2 gap-y-4">
											<div class="xs:w-1/2 w-full px-2">
												<div class="relative h-full">
													<div class="rounded-xl absolute inset-0 bg-[#F8F8F8] overflow-hidden">
														{/* <div class="absolute -skew-x-[20deg] w-[10vw] top-0 -left-12 bottom-0 bg-[#B50613] before:content-[''] before:absolute before:w-2/3 before:top-0 before:left-0 before:bottom-0 before:bg-black/20"></div> */}
														<div class="absolute -skew-x-[20deg] w-[10vw] top-0 -right-12 bottom-0 bg-[#B50613] before:content-[''] before:absolute before:w-2/3 before:top-0 before:right-0 before:bottom-0 before:bg-black/10"></div>
													</div>
													<div class="px-5 relative space-y-3 h-full">
														<div class="-mx-4 flex flex-wrap justify-between h-full">
															<div class="w-1/2 p-4 space-y-3">
																<h4 class="lg:text-2xl text-xl font-extrabold leading-tight uppercase text-gray-400">Possession Moyenne</h4>
																<h5 class="lg:text-2xl text-xl font-black uppercase">43.9%</h5>
															</div>
															<div class="w-1/2 px-4 flex items-end">
																<img src={require("../../assets/images/possession-moyenne.png")} alt="" class="max-w-full" />
															</div>
														</div>
													</div>
												</div>
											</div>

											<div class="xs:w-1/2 w-full px-2">
												<div class="relative h-full">
													<div class="rounded-xl absolute inset-0 bg-[#F8F8F8] overflow-hidden">
														{/* <div class="absolute -skew-x-[20deg] w-[10vw] top-0 -left-12 bottom-0 bg-[#B50613] before:content-[''] before:absolute before:w-2/3 before:top-0 before:left-0 before:bottom-0 before:bg-black/20"></div> */}
														<div class="absolute -skew-x-[20deg] w-[10vw] top-0 -right-12 bottom-0 bg-[#B50613] before:content-[''] before:absolute before:w-2/3 before:top-0 before:right-0 before:bottom-0 before:bg-black/10"></div>
													</div>
													<div class="px-5 relative space-y-3 h-full">
														<div class="-mx-4 flex flex-wrap justify-between h-full">
															<div class="w-1/2 p-4 space-y-3">
																<h4 class="lg:text-2xl text-xl font-extrabold leading-tight uppercase text-gray-400">Precise passes</h4>
																<h5 class="lg:text-2xl text-xl font-black uppercase">43.9%</h5>
															</div>
															<div class="w-1/2 px-4 flex items-end">
																<img src={require("../../assets/images/passes-précises.png")} alt="" class="max-w-full" />
															</div>
														</div>
													</div>
												</div>
											</div>

											<div class="xs:w-1/2 w-full px-2">
												<div class="relative h-full">
													<div class="rounded-xl absolute inset-0 bg-[#F8F8F8] overflow-hidden">
														{/* <div class="absolute -skew-x-[20deg] w-[10vw] top-0 -left-12 bottom-0 bg-[#B50613] before:content-[''] before:absolute before:w-2/3 before:top-0 before:left-0 before:bottom-0 before:bg-black/20"></div> */}
														<div class="absolute -skew-x-[20deg] w-[10vw] top-0 -right-12 bottom-0 bg-[#B50613] before:content-[''] before:absolute before:w-2/3 before:top-0 before:right-0 before:bottom-0 before:bg-black/10"></div>
													</div>
													<div class="px-5 relative space-y-3 h-full">
														<div class="-mx-4 flex flex-wrap justify-between h-full">
															<div class="w-1/2 p-4 space-y-3">
																<h4 class="lg:text-2xl text-xl font-extrabold leading-tight uppercase text-gray-400">Cartes</h4>
																<h5 class="lg:text-2xl text-xl font-black uppercase">6 yellow</h5>
																<h5 class="lg:text-2xl text-xl font-black uppercase">1 red</h5>
															</div>
															<div class="w-1/2 px-4 flex items-end">
																<img src={require("../../assets/images/cartes.png")} alt="" class="max-w-full" />
															</div>
														</div>
													</div>
												</div>
											</div>

											<div class="xs:w-1/2 w-full px-2">
												<div class="relative h-full">
													<div class="rounded-xl absolute inset-0 bg-[#F8F8F8] overflow-hidden">
														{/* <div class="absolute -skew-x-[20deg] w-[10vw] top-0 -left-12 bottom-0 bg-[#B50613] before:content-[''] before:absolute before:w-2/3 before:top-0 before:left-0 before:bottom-0 before:bg-black/20"></div> */}
														<div class="absolute -skew-x-[20deg] w-[10vw] top-0 -right-12 bottom-0 bg-[#B50613] before:content-[''] before:absolute before:w-2/3 before:top-0 before:right-0 before:bottom-0 before:bg-black/10"></div>
													</div>
													<div class="px-5 relative space-y-3 h-full">
														<div class="-mx-4 flex flex-wrap justify-between h-full">
															<div class="w-1/2 p-4 space-y-3">
																<h4 class="lg:text-2xl text-xl font-extrabold leading-tight uppercase text-gray-400">Draps propres</h4>
																<h5 class="lg:text-2xl text-xl font-black uppercase">0</h5>
															</div>
															<div class="w-1/2 px-4 flex items-end">
																<img src={require("../../assets/images/draps-propres.png")} alt="" class="max-w-full" />
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>

										<div class="panel space-y-4">
											<div class="panel-header w-full flex flex-wrap justify-center items-center gap-3">
												<div class="flex justify-between gap-3 w-full">
													<h3 class="xl:text-lg text-base font-extrabold uppercase">Joueurs</h3>
												</div>
											</div>
											<div class="panel-body w-full">
												<div class="relative">
													<img src={require("../../assets/images/football-ground.png")} alt="" />
													<div class="p-5 absolute inset-0">
														<div class="flex justify-center items-center h-full w-full">
															<div class="w-1/5 px-2 md:space-y-8 space-y-3">
																<div class="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
																	<img src={require("../../assets/images/players-list/1.png")} alt="" />
																</div>
															</div>
															<div class="w-1/5 px-2 md:space-y-8 space-y-3">
																<div class="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
																	<img src={require("../../assets/images/players-list/2.png")} alt="" />
																</div>
																<div class="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
																	<img src={require("../../assets/images/players-list/3.png")} alt="" />
																</div>
																<div class="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
																	<img src={require("../../assets/images/players-list/4.png")} alt="" />
																</div>
															</div>
															<div class="w-1/5 px-2 md:space-y-8 space-y-3">
																<div class="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
																	<img src={require("../../assets/images/players-list/5.png")} alt="" />
																</div>
																<div class="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
																	<img src={require("../../assets/images/players-list/6.png")} alt="" />
																</div>
																<div class="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
																	<img src={require("../../assets/images/players-list/1.png")} alt="" />
																</div>
																<div class="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
																	<img src={require("../../assets/images/players-list/2.png")} alt="" />
																</div>
															</div>
															<div class="w-1/5 px-2 md:space-y-8 space-y-3">
																<div class="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
																	<img src={require("../../assets/images/players-list/3.png")} alt="" />
																</div>
																<div class="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
																	<img src={require("../../assets/images/players-list/4.png")} alt="" />
																</div>
																<div class="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
																	<img src={require("../../assets/images/players-list/5.png")} alt="" />
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								)}
							</div>

						</div>
					</div>
				</div>
				<div className="lg:w-2/6 w-full px-2 space-y-8 sticky top-20">
					<div className="space-y-5">
						<div className="panel">
							{/* <div className="panel-header w-full flex flex-wrap justify-center items-center gap-3">
							<div className="flex justify-between gap-3 w-full">
								<button className="cursor-pointer"><img src="assets/images/icons/arrow-chevron-left.svg" alt="" /></button>
								<h3 className="xl:text-lg text-base font-extrabold uppercase">Lecture en cours</h3>
								<button className="cursor-pointer"><img src="assets/images/icons/arrow-chevron-right.svg" alt="" /></button>
							</div>
						</div> */}
							<div className="panel-body w-full space-y-8">
								<div className="bg-[url('../public/assets/images/curve-box.svg')] bg-[length:100%_auto] bg-no-repeat relative before:content-[''] before:absolute before:top-[6vw] before:left-0 before:bottom-0 before:right-0 before:bg-[#F8F8F8] before:rounded-b-lg">
									<div className="p-5 relative space-y-3">
										<div className="flex justify-between items-center gap-4 w-full">
											<div className="flex-1 font-secondary lg:text-3xl text-2xl uppercase font-black bg-gradient-to-r from-primary-950 to-primary-500 bg-clip-text text-transparent">sÊrie de victoires</div>
											<div className="flex-none pr-5">
												<span className="flex-1 font-secondary lg:text-5xl text-4xl uppercase font-black ">70%</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<TopTeams tableName={"best-teams"} teamList={teamList} />
						<div className="panel space-y-3">
							<div className="panel-header w-full flex flex-wrap justify-center items-center gap-3">
								<div className="flex justify-center gap-3 w-full">
									<h3 className="xl:text-lg text-base font-extrabold uppercase">Meilleurs joueurs</h3>
								</div>
							</div>
							<div className="panel-body w-full space-y-4 [&_.slick-arrow]:-top-7 [&_.slick-arrow]:z-10 before:[&_.slick-arrow]:hidden [&_.slick-prev]:left-0 [&_.slick-next]:right-0 ">
								<Slider {...settings}>
									<div className="pt-5 bg-[url('../public/assets/images/curve-box.svg')] bg-[length:100%_auto] bg-no-repeat relative before:content-[''] before:absolute before:top-[6vw] before:left-0 before:bottom-0 before:right-0 before:bg-[#F8F8F8] before:rounded-b-lg">
										<div className="px-5 relative space-y-3">
											<div className="flex justify-between items-start gap-4 w-full">
												<h4 className="lg:text-2xl text-lg font-black uppercase py-5">Kamory Doumbia</h4>
												<div className="flex-none w-2/3 -mt-4">
													<img src={require("../../assets/images/club-players/kamory-doumbia.png")} alt="" className="max-w-full" />
												</div>
											</div>
										</div>
									</div>
									<div className="pt-5 bg-[url('../public/assets/images/curve-box.svg')] bg-[length:100%_auto] bg-no-repeat relative before:content-[''] before:absolute before:top-[6vw] before:left-0 before:bottom-0 before:right-0 before:bg-[#F8F8F8] before:rounded-b-lg">
										<div className="px-5 relative space-y-3">
											<div className="flex justify-between items-start gap-4 w-full">
												<h4 className="lg:text-2xl text-lg font-black uppercase py-5">JulienLe Cardinal</h4>
												<div className="flex-none w-2/3 -mt-4">
													<img src={require("../../assets/images/club-players/julienLe-cardinal.png")} alt="" className="max-w-full" />
												</div>
											</div>
										</div>
									</div>
								</Slider>
							</div>
						</div>
					</div>
				</div>
			</div>
		</main>
	);
}

export default FixturesHistory

